import React from 'react';
import { numToCurrencyWithLocale } from 'helpers/numToCurrencyWithLocale';
import {
  IAmountsOwedReportsGroupTotalItem,
  IAmountsOwedReportsTableColumnHeading,
} from 'features/amountsOwedReports/amountsOwedReportsTypes';
import { useSelector } from 'react-redux';
import { organizationInfoSelector } from 'features/organization/organizationSlice';

interface TotalRowItemProps {
  item: IAmountsOwedReportsGroupTotalItem;
  column: IAmountsOwedReportsTableColumnHeading;
}

export const TotalRowItem: React.FC<TotalRowItemProps> = ({ item, column }) => {
  const organizationInfo = useSelector(organizationInfoSelector)

  return (
    <>
      <td key={column.value}>
        {column.value === 'amount'
          ? numToCurrencyWithLocale(item[column.value], organizationInfo.currency.code, 'en-US')
          : column.value === 'totalHours'
          ? item[column.value]
          : ''}
      </td>
    </>
  );
};

export default TotalRowItem;
